import type { ReactNode } from 'react';
import React from 'react';

import { IconButton } from '../../../elements/Button/IconButton/IconButton';
import { IconClose } from '../../../foundations/Iconography/IconClose';
import * as styles from '../styles/Header.styles';

type Layout = 'default' | 'stacked';

export interface HeaderProps {
  children: ReactNode;
  layout?: Layout;
  notificationStatus?: 'success' | 'normal';
  onCloseButtonClick: VoidFunction;
}

export const Header = ({
  children,
  layout = 'default',
  notificationStatus = 'normal',
  onCloseButtonClick,
}: HeaderProps) => (
  <div css={[styles.headerWrapper, styles[layout]]} data-success={notificationStatus === 'success'}>
    {children}
    <IconButton
      Icon={IconClose}
      aria-label="Close dialog"
      brandColorMode
      onClick={onCloseButtonClick}
      size="large"
    />
  </div>
);
